'use strict';

var TIMELINE_FILTRO_QUEBRA = {
  dia: {
    id: 'dia',
    descricao: 'Dia',
    campo: 'created_at'
  },
  estadio: {
    id: 'estadio',
    descricao: 'Estádio',
    campo: 'estadio_id'
  }
};

var SEM_ESTADIO = {
  id: null,
  descricao: 'Sem Estádio',
  abreviatura: 'Sem Estádio',
  ordem: ''
};

angular.module('webAgro1App').service('TimelineService', function($http, $uibModal, filterFilter, $q, HistoricosService, DadosMeteorologicosService) {

  var HUMANIZE_TIPOS = {
    estacao: 'Estação',
    pluviometro: 'Pluviômetro'
  };

  return {
    getMapValuesArray: function(arrayValues) {
      return (arrayValues || []).map(function(value) {
        return Array.isArray(value.id) ? value.id[1] : value.id;
      });
    },

    get: function(filters, quebra) {
      var deferred = $q.defer();
      var filtroQuebra = quebra || TIMELINE_FILTRO_QUEBRA.dia;

      var params = {
        propriedade: filters.propriedade.id,
        gleba: (filters.gleba || {}).id || null,
        tipo: filters.operacoes ? String(filters.operacoes) : null,
        representado: filters.ocorrencias || null,
        grupo_insumo: filters.gruposInsumos ? String(filters.gruposInsumos) : null,
        atividade: (filters.cultura || {}).id || null,
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        quebra: filtroQuebra.id
      };

      $http.get(SERVER + 'v1/all_historicos/timeline', {params: params}).then(function(result) {
        deferred.resolve((result.data || []).reduce(function(result, record) {
          var key = record[filtroQuebra.campo];
          if (filtroQuebra === TIMELINE_FILTRO_QUEBRA.estadio) {
            if (!record.estadio) {
              record.estadio = SEM_ESTADIO;
            }

            key = ('0000000000' + record.estadio.ordem).slice(-10) +'-'+ key;
          }
          result[key] = result[key] || [];
          result[key].push(record);
          return result;
        }, {}));
      }, deferred.reject);

      return deferred.promise;
    },

    getStructureValues: function(values) {
      var result = {};
      for (var index in values) {
        Object.keys(values[index]).forEach(function(key) {
          result[key] = result[key] || {};
          result[key][index] = values[index][key];
        });
      }

      var resultOrder = Object.keys(result).sort().reduce(function(objectResult, key) {
        var objectValues = result[key];

        Object.keys(objectValues).forEach(function(keyObjectValues) {
          _.sortBy(objectValues[keyObjectValues], 'created_at');
        });

        objectResult[key] = objectValues;

        return objectResult;
      }, {});

      return resultOrder;
    },

    getAllSelectFilters: function(filters) {
      var params = {
        propriedade: (filters.propriedade || {}).id
      };
      return HistoricosService.getAllSelectFilters(params);
    },

    getFilterOcorrencias: function(filters) {
      var deferred = $q.defer();
      var params = {
        propriedade: (filters.propriedade || {}).id,
        tipo: filters.operacoes ? String(filters.operacoes) : null
      };

      HistoricosService.listOcorrencias(params).then(function(result) {
        deferred.resolve((result.data || []).reduce(function(result, record) {
          var tipoOcorrencia = record.tp_ocorrencia_to_pt_br;
          result[tipoOcorrencia] = result[tipoOcorrencia] || [];
          result[tipoOcorrencia].push(record);
          return result;
        }, {}));
      }, deferred.reject);

      return deferred.promise;
    },

    getFilterGruposInsumos: function(filters) {
      var params = {
        propriedade: (filters.propriedade || {}).id
      };
      return HistoricosService.listGruposInsumos(params);
    },

    getOcorrenciasChecked: function(ocorrencias) {
      var _this = this;
      var ret = Object.keys(ocorrencias).map(function(key) {
        var values = _this.getMapValuesArray(filterFilter(ocorrencias[key], {checked: true}, true) || []);
        if (values.length > 0) {
          return values;
        }
      });

      return String(ret.filter(Boolean));
    },

    getFiltersColors: function() {
      return [
        {color: '#F2F6FC', flat: '#333333'},
        {color: '#CEA0E4', flat: '#7E349D'},
        {color: '#FDE3A7', flat: '#F39C12'},
        {color: '#27CBC0', flat: '#009B90'},
        {color: '#CE9C7B', flat: '#6E3C1B'}
      ];
    },

    getDadosMeteorologicos: function(filters) {
      var deferred = $q.defer();

      var params = {
        propriedade: filters.propriedade.id,
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null
      };

      DadosMeteorologicosService.list(params).then(function(data) {
        var result = (data.data || []).reduce(function(result, value) {
          var key = value.tipo + '-' + value.cd_pluviometro;
          value.descricao += ' (' + HUMANIZE_TIPOS[value.tipo] + ')';
          result[key] = result[key] || [];
          result[key].push(value);

          return result;
        }, {});

        Object.keys(result).forEach(function(key) {
          _.sortBy(result[key], 'data');
        });

        deferred.resolve(result);
      }, deferred.reject);

      return deferred.promise;
    },

    _getGraficoMeteorologico: function(dados, dadosMeteorologicos, filters, reduceFunction) {
      if (!Object.keys(dados || {}).length || !Object.keys((dadosMeteorologicos || {}).dados || {}).length) {
        return;
      }

      var resultDados = Object.keys(dados).reduce(reduceFunction, {});
      resultDados = Object.values(resultDados);

      return {
        dados: resultDados,
        maxSerieChuva: _.maxBy(resultDados, 'chuva').chuva
      };
    },

    getGraficoMeteorologico: function(dados, dadosMeteorologicos, filters) {
      var _this = this;

      return this._getGraficoMeteorologico(dados, dadosMeteorologicos, filters, function(result, key, index, array) {
        var keyRecord = Object.keys(dados[key])[0];
        var record = dados[key][keyRecord][0];

        var previousKeyArray = array[index-1] || null;
        var data = previousKeyArray ? _this.getSortDateObject(dados[previousKeyArray]).reverse()[0] : null;
        var dataInicial = (data ? moment(data).add(1, 'days') : moment(array[0])).format('Y-MM-DD');

        result[key] = {
          chuva: 0,
          dataInicial: dataInicial,
          dataFinal: record.created_at
        };

        Object.keys(dadosMeteorologicos.dados).forEach(function(keyMeteorologico) {
          if (!dadosMeteorologicos.selected || dadosMeteorologicos.selected === keyMeteorologico) {
            result[key].chuva += dadosMeteorologicos.dados[keyMeteorologico].reduce(function(soma, recordMeteorologico) {
              if (result[key].dataInicial <= recordMeteorologico.data && recordMeteorologico.data <= result[key].dataFinal) {
                soma += recordMeteorologico.chuva;
              }
              return soma;
            }, 0);
          }
        });

        return result;
      }, {});
    },

   getGraficoMeteorologicoEstadio: function(dados, dadosMeteorologicos, filters) {
    var _this = this;

    return this._getGraficoMeteorologico(dados, dadosMeteorologicos, filters, function(result, key, index, array) {
        var previousKeyArray = array[index - 1];
        var nextKeyArray = array[index + 1];
        var data = nextKeyArray ? _this.getSortDateObject(dados[nextKeyArray])[0] : null;
        var dataFinal = (data ? moment(data).subtract(1, 'day') : moment(filters.dataFinal)).format('Y-MM-DD');

        var dataInicial = _this.getSortDateObject(dados[key])[0];

        result[key] = {
          chuva: 0,
          dataInicial: dataInicial,
          dataFinal: dataInicial > dataFinal ? dataInicial : dataFinal
        };

        if (previousKeyArray) {
          Object.keys(dadosMeteorologicos.dados).forEach(function(keyMeteorologico) {
            if (!dadosMeteorologicos.selected || dadosMeteorologicos.selected === keyMeteorologico) {
              result[key].chuva += dadosMeteorologicos.dados[keyMeteorologico].reduce(function(soma, recordMeteorologico) {
                if (result[key].dataInicial <= recordMeteorologico.data && recordMeteorologico.data <= result[key].dataFinal) {
                  soma += recordMeteorologico.chuva;
                }
                return soma;
              }, 0);
            }
          });
        }


        return result;
      }, {});
    },


    getSortDateObject: function(object) {
      var arrayValues = Object.values(object).reduce(function(result, value) {
        return result.concat(value);
      });

      var datas = arrayValues.map(function(value) {
        return value.created_at;
      });

      return datas.sort();
    }
  };
});
